enum MessageDeliveryType {
  Email = '0',
  SMS = '1',
  Fax = '3'
}

export { MessageDeliveryType };
